import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
// eslint-disable-next-line import/extensions
import { connect } from 'redux-zero/react';
import { injectIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import OnVisible, { setDefaultProps } from 'react-on-visible';

import { actions } from '../../shared/store.js';
import PartnerWithUsService from './partner-with-us.service.js';

import { Title, SmallTitle } from '../../components/title/title.component.js';

// import PageNotFound from '../../components/not-found/page-not-found.js';

import './partner-with-us.page.scss';

class PartnerWithUsPage extends Component {
	static prefetchData = async language =>
		PartnerWithUsService.getData(language);

	state = {
		hasError: false,
	};

	componentDidMount() {
		const { partnerWithUs, setLoading } = this.props;

		if (!partnerWithUs) {
			this.fetchData();
		} else {
			setLoading(false);
		}
	}

	componentDidUpdate(prevProps) {
		const { language } = this.props;

		if (prevProps.language.value !== language.value) {
			this.fetchData();
		}
	}

	fetchData() {
		const { setLoading, setPartnerWithUs, language } = this.props;

		setLoading(true);

		PartnerWithUsPage.prefetchData(language.value)
			.then(data => {
				setPartnerWithUs(data);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);

				this.setState({
					hasError: true,
				});
			});
	}

	render() {
		const { hasError } = this.state;
		const {
			// isLoading,
			intl,
			partnerWithUs,
		} = this.props;

		setDefaultProps({
			visibleClassName: 'visible',
			percent: 20,
		});

		// if (isLoading) return null;

		if (hasError || !partnerWithUs) {
			return null;
		}

		const {
			title,
			headerImage,
			description,
			investorTitle,
			investorDescription,
			clientTitle,
			clientDescription,
			bodyImage,
			partnerTitle,
			partnerDescription,
		} = partnerWithUs;

		return (
			<div id="partner-with-us-page">
				<Helmet>
					<title>
						{intl.formatMessage({
							id: 'navigation.partner-with-us',
						})}
					</title>
					<meta name="description" content={description} />
					<link
						rel="canonical"
						href={`${process.env.REACT_APP_URL}/partner-with-us`}
					/>

					<meta
						property="og:url"
						content={`${process.env.REACT_APP_URL}/partner-with-us`}
					/>
				</Helmet>

				<section className="initial-section">
					{headerImage.path && (
						<img
							className="initial-section-image"
							src={`${process.env.REACT_APP_API_ENDPOINT + headerImage.path}`}
							alt="Partner-With-us-Header"
						/>
					)}
					<div className="container container-fluid">
						<div className="title">
							<div className="title-wrapper">
								<Title label={title} />
							</div>
						</div>
					</div>
				</section>

				<section className="middle-section">
					<div className="container container-fluid">
						<div className="row text-left">
							<OnVisible className="col-xs-12 col-md-10 main-description">
								<h3>{description}</h3>
							</OnVisible>

							<div className="col-xs-12 col-md-8 text-left">
								<OnVisible className="wrapper investor">
									<div className="col-xs-12 col-md-4 left-title">
										<div className="icon" />
										<SmallTitle label={investorTitle} />
									</div>
									<div className="col-xs-12 col-lg-7 description">
										<p>{investorDescription}</p>
									</div>
								</OnVisible>

								<OnVisible className="wrapper client">
									<div className="col-xs-12 col-md-4 left-title">
										<div className="icon" />
										<SmallTitle label={clientTitle} />
									</div>
									<div className="col-xs-12 col-lg-7 description">
										<p>{clientDescription}</p>
									</div>
								</OnVisible>
							</div>
						</div>

						<div className="image-element">
							<OnVisible className="image">
								{bodyImage.path && (
									<img
										className="initial-section-image"
										src={`${process.env.REACT_APP_API_ENDPOINT +
											bodyImage.path}`}
										alt="Partner-With-us-Header"
									/>
								)}
							</OnVisible>
						</div>
					</div>
				</section>

				<section className="bottom-section">
					<div className="container container-fluid">
						<div className="row">
							<div className="col-xs-12 col-md-5 text-wrapper">
								<OnVisible className="title">
									<h3>{partnerTitle}</h3>
								</OnVisible>
								<OnVisible className="description">
									<p>{partnerDescription}</p>
								</OnVisible>
								<OnVisible className="link-portfolio">
									<Link to="/portfolio" className="our-portfolio">
										{intl.formatMessage({
											id: 'partnerWithUs.portfolio',
										})}
									</Link>
								</OnVisible>
							</div>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

const mapToProps = ({ language, partnerWithUs }) => ({
	language,
	partnerWithUs,
});

export default withRouter(
	injectIntl(
		connect(
			mapToProps,
			actions,
		)(PartnerWithUsPage),
	),
);

export { PartnerWithUsPage };
